;(() => {
  const STYLE_ID = 'nm-recharge-overrides'
  const CSS = `li {
  margin-block: 0 !important;
  padding-left: 20px;
  padding-block: 0 !important;
}
li + li {
  margin-top: 0px !important;
}
li p {
  margin: 0 !important;
  font-size: 13px;
  line-height: 1.4;
}
p {
  margin-top: 0;
  line-height: 0.5;
  margin-bottom: 10px;
}
p a {
  font-size: 13px;
  color: rgb(65, 67, 72);
}
p br {
  display: none;
}
.rc-purchase-option__sub-container {
  gap: 2px !important;
}
.rc-plans__label {
  font-size: 13px !important;
}
.rc-plans-dropdown__select {
  font-size: 13px !important;
}
li::before {
  height: 16px;
  width: 16px;
  top: 2px !important;
}`

  const watchedRoots = new WeakSet()

  function inject (root) {
    if (!root || root.querySelector(`#${STYLE_ID}`)) return

    const style = document.createElement('style')
    style.id = STYLE_ID
    style.textContent = CSS
    root.appendChild(style)
  }

  function watch (root) {
    if (!root || watchedRoots.has(root)) return

    watchedRoots.add(root)
    new MutationObserver(() => {
      inject(root)
      root.querySelectorAll('*').forEach(element => {
        if (element.shadowRoot) watch(element.shadowRoot)
      })
    }).observe(root, { childList: true, subtree: true })
  }

  function scan (node) {
    if (!node || !node.querySelectorAll) return

    node
      .querySelectorAll('recharge-subscription-widget, rc-benefits')
      .forEach(host => {
        if (!host.shadowRoot) return

        inject(host.shadowRoot)
        watch(host.shadowRoot)
        scan(host.shadowRoot)
      })
  }
  scan(document)

  new MutationObserver(() => {
    scan(document)
  }).observe(document.documentElement, { childList: true, subtree: true })
})()
